export const getFirmOptionTestId = (slug: string): string => slug;
